






















import Vue from "vue";
import Content from "./components/Content.vue";

export default Vue.extend({
  name: "App",

  components: {
    Content
  }
});
